<template>
  <el-table-column :label="label" :prop="prop" class-name="private_id" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: 'プライベート識別'
    },
    prop: {
      type: String,
      default: 'private_id'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  td,
  th {
    &.private_id {
      width: 12em;
    }
  }
}
</style>
